import { render, staticRenderFns } from "./TaBs.vue?vue&type=template&id=b0430cbe&scoped=true"
import script from "./TaBs.vue?vue&type=script&lang=js"
export * from "./TaBs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0430cbe",
  null
  
)

export default component.exports